import SET_BANNER from './types';

const defaultBanner = {
  active: false,
  text: '',
  active_button: true,
  button_text: '',
  button_url: '',
};

export const state = {
  fetched: false,
  active: Object.assign({}, defaultBanner),
};

export const mutations = {
  [SET_BANNER](state, banner) {
    state.fetched = true;
    state.active = banner;
  },
};



// WEBPACK FOOTER //
// ./src/shared/components/banner/store/mutations.js